import DriverAdminDetails from "../DriverAdminDetails";

export default DriverAdminDetails;
